import React, { useState, useRef, ChangeEvent, useEffect } from "react";

import "./SearchDown.scss";

interface IProps {
  defaultValue?: string,
  label?: string,
  placeholder?: string,
  icon?: string,
  type?: string,
  required?: boolean,
  onChange?(e: ChangeEvent<HTMLInputElement>): void,
  id?: string,
  onSearch(value:string): void,
  searchResults: string[],
  onSelect(value: string): void,
  onClear?(): void,
  showClear?: boolean,
  limit?: number
}

const SearchDown: React.FC<IProps> = (props) => {
  const [inputClass, setInputClass] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const inputPreClass = props.icon ? "searchInput hasIcon" : "searchInput noIcon";

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const setFocus = () => {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
      setInputClass("focused");
      setIsOpen(true);
    }
  }

  const onBlur = () => {
    setInputClass("");
  }

  const hasValue = () => {
    if (inputRef && inputRef.current) {
      if (inputRef.current.value.length > 0) {
        return true;
      }
    }

    return false;
  }

  const setValue = (value: string) => {
    if (inputRef && inputRef.current) {
      inputRef.current.value = value;
    }

    props.onSelect(value);
    setIsOpen(false);
  }

  const handleClear = () => {
    if (inputRef && inputRef.current) {
      inputRef.current.value = "";
      if (props.onClear) {
        props.onClear();
      }
    }
  }

  return (
    <div className="SearchDown" ref={containerRef}>
      <div onClick={() => { setFocus(); }} className={"focused " + props.placeholder ? inputPreClass +" "+ inputClass : hasValue() ? inputPreClass +" "+ inputClass + " noPlaceholder focused" : inputPreClass +" "+ inputClass + " noPlaceholder"}>
        {props.label ? <label><span>{props.label}</span></label> : null}
        {props.icon && <img className="icon" alt="input icon" src={props.icon} />}
        <input
          defaultValue={props.defaultValue ? props.defaultValue : ""}
          id={props.id ? props.id : ""}
          onChange={(e) => { if (props.onChange) { props.onChange(e); } props.onSearch(e.target.value); }}
          required={props.required ? true : false}
          onFocus={() => { setFocus(); }}
          type={props.type ? props.type : "text"}
          onBlur={() => { onBlur(); }}
          ref={inputRef}
          placeholder={props.placeholder ? props.placeholder : ""} 
          autoComplete="off"
        />
        {props.showClear && hasValue() && (
          <button className="clear-button" onClick={(e) => { e.stopPropagation(); handleClear(); }}>
            ×
          </button>
        )}
      </div>
      {isOpen && props.searchResults.length > 0 && <div className="searchResults">
        <ul>
          {props.searchResults.map((item: string, index: number) => {
            return(<li key={index} onClick={() => { setValue(item); }}>{item}</li>);
          })}
        </ul>
      </div>}
    </div>
  );
};

export default SearchDown;